import { videosSlice } from './slice';

export const {
    changeSharedVideoFormPrivacy,
    changeSharedVideoFormTitle,
    changeSharedVideoFormDescription,
    changeSharedVideoFormVideoData
} = videosSlice.actions;
